document.addEventListener('DOMContentLoaded', function () {
  const videoAntiSleep = document.querySelector('.js-videoAntiSleep');

  if (!videoAntiSleep) {
    return;
  }

  let wakeLock = null;

  async function requestWakeLock() {
    try {
      wakeLock = await navigator.wakeLock.request('screen');
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  }

  function releaseWakeLock() {
    if (wakeLock !== null) {
      wakeLock.release();
      wakeLock = null;
    }
  }

  videoAntiSleep.addEventListener('click', function () {
    videoAntiSleep.classList.toggle('is-active');
    if (videoAntiSleep.classList.contains('is-active')) {
      requestWakeLock();
    } else {
      releaseWakeLock();
    }
  });
});
